import * as a from 'actions/yoti';

const initial = {
  visibility: false,
};

const reducer = (state = initial, action = null) => {
  switch (action.type) {
    case a.SHOW_YOTI_MODAL:
      return {
        ...state,
        visibility: true,
      };
    case a.HIDE_YOTI_MODAL:
      return {
        ...state,
        visibility: false,
      };
    default:
      return state;
  }
};

export default reducer;
